// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Excel {\n  margin-bottom: 35px;\n  margin-left: 20px;\n}\n\n/* https://stackoverflow.com/a/13924997 */\n.limit-line-2 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  -webkit-box-orient: vertical;\n}\n", ""]);
// Exports
module.exports = exports;
